import Image from 'next/image'
import { getReadableImageUrl } from "@/lib/directus";
import { sanitizeHTML } from "@/lib/utils";

interface WrittenByData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  image?: {
    alt: string;
    image_file: {
      image: {
        id: string;
        filename_download: string;
      };
    };
  };
}

export const fields = [
  // heading
  "heading.text",
  "heading.title",
  
  // text
  "text.text",
  
  // image
  "image.alt",
  "image.image_file.image.id",
  "image.image_file.image.filename_download",
] as const;

interface WrittenByProps {
  data?: WrittenByData;
}

export default function WrittenBy({ data }: WrittenByProps) {
  // Get image details from directus data
  const imageId = data?.image?.image_file?.image?.id;
  const imageFilename = data?.image?.image_file?.image?.filename_download;
  const imageAlt = data?.image?.alt;
  const imageUrl = imageId && imageFilename ? 
    getReadableImageUrl(imageId, imageFilename) : 
    "/images/9790004516.jpg_exif11.png";

  return (
    <section className="w-full bg-white px-8 py-8">
      <div className="container mx-auto flex items-center justify-center gap-8 lg:gap-12 py-10">
        {/* Author Image */}
        <div className="relative h-50 w-30 flex-shrink-0 overflow-hidden rounded-full">
          <Image
            src={imageUrl}
            alt={imageAlt || ""}
            width={208}
            height={208}
            className="object-cover w-full h-full -mt-5"
            priority
          />
        </div>

        {/* Author Info */}
        <div className="flex w-[60%]  lg:max-w-xl flex-col gap-3">
          <h2 className="text-[1.5rem] leading-9 font-essonnes font-light md:text-4xl md:leading-[3.06rem] lg:text-[2.5rem] lg:leading-[3.4rem] tracking-tight text-[#193762]">
            {data?.heading?.title}
          </h2>
          <div 
            className="text-[1rem] font-normal leading-normal xl:text-xl font-greycliff tracking-tight text-[#193762] [&_a]:underline [&_a:hover]:no-underline"
            dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || "")}
          />
        </div>
      </div>
    </section>
  )
} 